import React from 'react';
import styles from './FormMessage.module.scss';

const FormMessage = ({ message, type = 'error' }) => {
  if (!message) {
    return null;
  }

  return (
    <div className={styles['form-action-message']}>
      <p>{message}</p>
    </div>
  );
};

export default FormMessage; 